import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAutoSize"><Path fillRule="evenodd" clipRule="evenodd" d="M20 2H4V22H20V2ZM5.5 11V3.5H18.5V20.5H13V11H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoSize;
